import { JOB_STATUSES, RPC_TYPES, trimText } from 'utils';
import { getCdnImageUrl } from 'utils/image-handler';
import default2DRpc from 'assets/Ui/default2DModel.png';
import default3DRpc from 'assets/Ui/default3DModel.png';
import _ from 'lodash';

const { VITE_CDN_HOST: cdnHost } = process.env;

export const formatRpcImage = (
  guid,
  jobType,
  width = 164,
  height = 164,
) => {
  const thumbnailCache = `${cdnHost}/public/service.thumbnail-cache`;

  if (!guid) {
    return jobType === RPC_TYPES.png ? default2DRpc : default3DRpc;
  }

  return getCdnImageUrl(`${thumbnailCache}/${guid}.rpc.png`, { width, height });
};

export const getScaledValues = cardScale => {
  const getScale = value => (value * cardScale) / 100;

  return {
    cardContainer: {
      width: getScale(360),
      height: getScale(360),
    },
    grid: {
      column: getScale(60),
      row: getScale(90),
    },
    image: {
      width: getScale(240),
      height: getScale(240),
      spacer: getScale(35),
      default: {
        width: getScale(180),
        height: getScale(220),
      },
    },
    jobStatus: {
      width: getScale(40),
      height: getScale(40),
      spacer: getScale(20),
      processIcon: {
        width: getScale(35),
        height: getScale(35),
      },
    },
    icons: {
      width: getScale(43),
      height: getScale(43),
      spacer: getScale(5),
      spacerBetween: getScale(15),
    },
    font: {
      size: getScale(25),
    },
    popover: {
      top: getScale(75),
      left: getScale(70),
    },
    button: {
      width: getScale(40),
      height: getScale(50),
    },
    buttonContainer: {
      height: getScale(270),
    },
  };
};

export const buildTitle = (job, status, title, isCardView) => {
  if (job?.job_guid && job?.filename !== '') {
    return trimText(job?.filename, isCardView ? 20 : 100, true);
  }

  if (status && status !== JOB_STATUSES.COMPLETED) {
    return _.startCase(status);
  }

  return trimText(title, isCardView ? 20 : 100, true);
};

export const getQuerySortingParameters = value => {
  if (value === 'ascending') return 'TITLE_ASC';
  if (value === 'descending') return 'TITLE_DESC';
  if (value === 'oldest first') return 'CREATED_OLD_TO_NEW';
  if (value === 'newest first') return 'CREATED_NEW_TO_OLD';
};

// Format availability is in transition: it is stored as a boolean and currently serialised as
// AVAILABLE / NOT AVAILABLE, but the enum also carries QUEUED / PROCESSING / FAILED which the
// conversion worker will start emitting. Read availability through getFormatState, never by
// comparing to a literal, so the UI picks those states up without a change.
export const FORMAT_STATES = {
  available: 'available',
  publishable: 'publishable',
  publishing: 'publishing',
  failed: 'failed',
};

export const getFormatState = availability => {
  if (availability === true) return FORMAT_STATES.available;
  if (availability === false) return FORMAT_STATES.publishable;

  switch (String(availability).toLowerCase()) {
    case 'available':
      return FORMAT_STATES.available;
    case 'queued':
    case 'processing':
      return FORMAT_STATES.publishing;
    case 'failed':
      return FORMAT_STATES.failed;
    default:
      return FORMAT_STATES.publishable;
  }
};

export const isAvailable = availability => getFormatState(availability) === FORMAT_STATES.available;

// The API returns these, but there is no conversion behind them yet, so they are never offered for
// publishing. They still appear under Available if a model already has them.
export const UNPUBLISHABLE_FORMATS = [ 'TWINMOTION', 'LUMION', 'RHINO_3DM' ];

export const customStartCase = str => {
  if (!str) return '';

  let modified = str.replace(/[_-]+/g, ' ');

  modified = modified.replace(/([a-z])([A-Z])/g, '$1 $2');

  const tokens = modified.split(/\s+/);

  return tokens.join(' ');
};



